export const failureHash = {
    ACTION_BLOCKED: "API__EP__POST__ACTION_BLOCKED",
    EMAIL_NOT_VERIFIED: "API__EP__POST__EMAIL_NOT_VERIFIED",
    PAGES_LIMIT_HIT: "API__EP__POST__PAGES_LIMIT_HIT",
    PLAN_SUBSCRIPTION_ENDED: "API__EP__POST__PLAN_SUBSCRIPTION_ENDED",
    POST_ALREADY_EXISTS: "API__EP__POST__POST_ALREADY_EXISTS",
    POST_IMMUTABLE_WHEN_COMPLETED: "API__EP__POST__POST_IMMUTABLE_WHEN_COMPLETED",
    POST_IMMUTABLE_WHEN_FAILED: "API__EP__POST__POST_IMMUTABLE_WHEN_FAILED",
    POST_IMMUTABLE_WHEN_LOCKED: "API__EP__POST__POST_IMMUTABLE_WHEN_LOCKED",
    POST_LIMIT_HIT: "API__EP__POST__POST_LIMIT_HIT", // You have exceed scheduled post limit
};
//# sourceMappingURL=post.static.js.map